const SERVICES_STORAGE_KEY = 'pymego_services'

function readAll() {
  try {
    const parsed = JSON.parse(localStorage.getItem(SERVICES_STORAGE_KEY))

    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
  } catch {
    return {}
  }
}

// El servidor de login es el unico que resuelve el mapa de servicios de un
// cliente (entre ellos la URL del backend). Se guarda en disco, indexado por
// cliente, para poder entrar al backend aunque el login este caido.
export function saveClientServices(clientId, services) {
  if (!clientId || !services?.be) return

  try {
    const all = readAll()

    all[clientId] = services
    localStorage.setItem(SERVICES_STORAGE_KEY, JSON.stringify(all))
  } catch {
    // Cuota agotada o storage bloqueado: seguir sin cache.
  }
}

export function readClientServices(clientId) {
  if (!clientId) return null

  const services = readAll()[clientId]

  return services?.be ? services : null
}
